'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.split = undefined;

var _ace = require('./ace.js');

var _ace2 = _interopRequireDefault(_ace);

var _split = require('./split.js');

var _split2 = _interopRequireDefault(_split);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

exports.split = _split2.default;
exports.default = _ace2.default;


//////////////////
// WEBPACK FOOTER
// ./node_modules/.5.10.0@react-ace/lib/index.js
// module id = 1151
// module chunks = 0